
<link rel="stylesheet" href="/style/auth.css">
<script>
import { Col, Container, Row } from "sveltestrap";
export let signupHeader = 'Hello, Friend!'
export let signupCallToAction = 'Enter your some information and begin your journey with us'
export let signupUrl = '#'
export let loginFunc = (email, pass) => {alert(email)}
let emailVal = null
let passwordVal = null
let loginRes = {}
let loading
</script>

<div class="full-screen">
  <div class="container" id="container" style="margin: 3rem;">
    <Row class="align-items-center" style="height:100%;">
      <Col xs="12">
        <Row style="" class="justify-content-center">
          <Col sm="6" style="padding: 1rem;">
              <form on:submit={ (e)=> { e.preventDefault(); loading=true; loginFunc(emailVal, passwordVal).then(res => {loginRes = res; loading = false})}}>
                <h1>Sign in</h1>
                <!-- <span>or use your account</span> -->
                <!-- <a href="#" class="social"><i class="fab fa-facebook-f"></i></a>
                <a href="#" class="social"><i class="fab fa-google-plus-g"></i></a>
                <a href="#" class="social"><i class="fab fa-linkedin-in"></i></a> -->
                <input type="email" placeholder="Email" bind:value={emailVal} />
                <input type="password" placeholder="Password" bind:value={passwordVal} />
                <!-- <a href="#">Forgot your password?</a> -->
                <button class="{loading ? 'loading' : ''}">Sign In</button>
                {#if loginRes.message}
                  <p>
                    {loginRes.message}
                  </p>
                {/if}
              </form>
          </Col>
        </Row>
      </Col>
      <Col xs="12">
        <Row class="justify-content-center">
          <Col sm="6">
            <p>
              No account? No problem. Sign up <a style="color: blue!important;" href="{signupUrl}">here</a>
            </p>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
</div>